import {DG_axios} from "../../../../custom/axios";

const BASE_URI = `/dogoo/shift-config-rest/v2.0/shift-configs/`;
const BASE_SHIFT_REGISTRATION_API = "/dogoo/application-shift-rest/v2.0/application-shifts-by-date";

export async function  loadShiftsApi (params) {

    const response = await DG_axios.get(
        BASE_URI
        , {
            params
        })
    return response?.data || []

};

export async function  loadShiftApi(shiftId){
    const response = await DG_axios.get(BASE_URI + shiftId);
    return response.data || [];
};

export async function deleteShiftApi(shiftIds){
    const response = await DG_axios.delete(`${BASE_URI}${shiftIds}`);
    return response.data || [];
};

export async function  addShiftApi(shift){
    const response = await DG_axios.post(BASE_URI, shift);
    return response.data || [];
};

export async function updateShiftApi(shiftId, shift){
    const response = await DG_axios.put(`${BASE_URI}${shiftId}`, shift);
    return response.data || [];
};

export async function  loadListApplicationShiftByDateAndStatus (startDate, endDate, status,search) {

    const response = await DG_axios.get(
        BASE_SHIFT_REGISTRATION_API
        , {
            params: {
                startDate,
                endDate,
                status,
                search
            }
        })
    return response?.data || []

};